import Button from '@mui/material/Button';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import clsx from 'clsx';
import React from 'react';
import type { ButtonProps } from '@mui/material/Button';
import type { ReactNode } from 'react';

// Create MUI v5 theme
const theme = createTheme({
  palette: {
    primary: { main: '#f0bf3f' },
    secondary: { main: '#7b1b17' },
  },
  typography: {
    fontSize: 22,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          color: 'white',
        },
      },
    },
  },
});

// Styled button
const StyledButton = styled(Button)({
  borderRadius: '1rem',
  fontSize: '2rem',
  margin: '.5rem 0',
  height: '5rem',
});

interface ClassNamesProps extends ButtonProps {
  children?: ReactNode;
  className?: string;
}

const ClassNames: React.FC<ClassNamesProps> = ({
  children,
  className,
  ...other
}) => {
  return (
    <ThemeProvider theme={theme}>
      <StyledButton className={clsx(className)} {...other}>
        {children || 'class names'}
      </StyledButton>
    </ThemeProvider>
  );
};

ClassNames.displayName = 'ClassNames';

export default ClassNames;
